import { apiBaseUrl } from "./config";
import { sendGetRequest, setUtilsToken } from "./utils";

const baseUrl = `${apiBaseUrl}/statements`;
let token;

export function setStatementsToken(t) {
  token = t;
  setUtilsToken(t);
}

export async function getStatementsReporte({ ciclo, regionId, diocesisId, comunidadId } = {}) {
  const params = new URLSearchParams({ ciclo });
  if (regionId) params.append('regionId', regionId);
  if (diocesisId) params.append('diocesisId', diocesisId);
  if (comunidadId) params.append('comunidadId', comunidadId);
  return sendGetRequest(`${baseUrl}/reporte?${params.toString()}`);
}

export async function getComunidadBankStatements(comunidadId, ciclo) {
  let url = `${baseUrl}/comunidad/${comunidadId}`;
  if (ciclo) {
    url += `?ciclo=${ciclo}`;
  }
  return sendGetRequest(url);
}

export async function getComunidadBankStatementReport(comunidadId, ciclo) {
  const url = `${baseUrl}/comunidad/${comunidadId}/report?ciclo=${ciclo}`;
  return sendGetRequest(url);
}

export async function uploadComunidadBankStatement(comunidadId, ciclo, month, file) {
  const url = `${baseUrl}/comunidad/${comunidadId}`;
  const formData = new FormData();
  formData.append('ciclo', ciclo);
  formData.append('month', month);
  formData.append('statement', file);

  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const r = await fetch(url, {
    method: 'POST',
    body: formData,
    headers
  });

  let data;
  try {
    data = await r.json();
  }
  catch (e) {
    data = { message: r.statusText || 'Error al subir archivo.' };
  }

  if (!r.ok) {
    throw {
      status: r.status,
      message: data?.message || 'Error al subir archivo.'
    };
  }

  return data;
}
